import { AttributesMixin, define } from "@type-r/models";
import { CountsModel } from "./countsModel";
import { restfulIO } from "./endpoint";

export interface CreditNoteCount extends AttributesMixin<typeof CreditNoteCount> { }

@define
export class CreditNoteCount extends CountsModel {
    static endpoint = restfulIO('api/v1/ingest/creditNotes/counts');

    static attributes = {
        ...CountsModel.attributes
    };

}
